// extracted by mini-css-extract-plugin
module.exports = {"text":"duplicate-file-detected_text__4UsZg","bold":"duplicate-file-detected_bold__2WqHe","button-row":"duplicate-file-detected_button-row__1dUjR"};